@if (groupedChatSessions.length) {
    <h3 class="sessions-history-title">Chat Sessions</h3>
    <div class="sessions-list">
        @for (group of groupedChatSessions; track $index) {
            <div class="month-year-group">
                <p class="month-year-title body-sm-14-semibold">{{ group.monthYear }}</p>
                @for (session of group.sessions; track $index) {
                    <p class="session-title" (click)="openChat(session.id)">
                        <span class="session-title-text">{{ session.title }}</span>
                    </p>
                }
            </div>
        }
    </div>
}
